<div
  class="locate-microchip-background locate-microchip-height"
  [ngClass]="'locate-microchip-background-' + positioning"
></div>
<div class="container locate-microchip-step locate-microchip-height" [ngClass]="positioning">
  <div class="locate-number" [attr.data-before-content]="dataBeforeContent">
    <img src="assets/images/petsChip/identi-paw-asset.svg" alt="white-background" />
  </div>
  <div class="locate-string">
    <h3>{{ title }}</h3>
    <p *ngIf="text">
      {{ text }}
    </p>
    <h5 *ngIf="listHeader" class="list-header">{{ listHeader }}</h5>
    <ul *ngIf="listDots">
      <li *ngFor="let dot of listDots">{{ dot }}</li>
    </ul>
  </div>
</div>
